import { Box, Typography } from "@mui/material";
import { ReactNode } from "react";

interface DetailRowProps {
  label: string;
  children: ReactNode;
  alignValue?: "left" | "right" | "center";
}

export default function DetailRow({
  label,
  children,
  alignValue = "right",
}: DetailRowProps) {
  return (
    <>
      <Typography
        variant="body1"
        component="dt"
        sx={{
          fontWeight: 400,
          margin: 0,
          padding: 0,
          display: "flex",
          alignItems: "center",
          lineHeight: 1.5,
        }}
      >
        {label}:
      </Typography>
      <Box
        component="dd"
        sx={{
          textAlign: alignValue,
          display: "flex",
          justifyContent:
            alignValue === "right"
              ? "flex-end"
              : alignValue === "left"
                ? "flex-start"
                : "center",
          alignItems: "center",
          margin: 0,
          padding: 0,
        }}
      >
        {children}
      </Box>
    </>
  );
}

